import React from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Activity } from 'lucide-react';

const MonthlyChangesTable = ({ monthlyData }) => {
  if (!monthlyData || monthlyData.length === 0) return null;

  // Show last 12 months
  const recentData = monthlyData.slice(-12);

  const getChangeBadgeVariant = (change) => {
    if (change > 10) return 'success';
    if (change > 0) return 'info';
    if (change > -10) return 'warning';
    return 'danger';
  };

  const getTrendIcon = (change) => {
    if (change > 5) return <TrendingUp className="text-success" size={16} />;
    if (change > 0) return <TrendingUp className="text-info" size={16} />;
    if (change > -5) return <TrendingDown className="text-warning" size={16} />;
    return <TrendingDown className="text-danger" size={16} />;
  };

  const formatDate = (month, year) => {
    // Create date from month and year
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 
                      'July', 'August', 'September', 'October', 'November', 'December'];
    return `${monthNames[month - 1]} ${year}`;
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="card-title mb-0 d-flex align-items-center">
          <Activity className="text-warning me-2" size={20} />
          Recent Monthly Changes
        </h5>
      </Card.Header>
      <Card.Body>
        <div className="table-responsive">
          <Table striped hover className="monthly-changes-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Month</th>
                <th>Interest Score</th>
                <th>Change (%)</th>
                <th>Trend</th>
              </tr>
            </thead>
            <tbody>
              {recentData.map((month, index) => {
                const change = month.pct_change || 0;
                return (
                  <tr key={index}>
                    <td>{formatDate(month.month, month.year)}</td>
                    <td>{month.month_name}</td>
                    <td>{month['Singapore PR']}</td>
                    <td>
                      <Badge bg={getChangeBadgeVariant(change)}>
                        {change.toFixed(1)}%
                      </Badge>
                    </td>
                    <td>{getTrendIcon(change)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MonthlyChangesTable;
